import { Navigate, useRoutes } from 'react-router-dom';
import MainLayout from 'src/layouts/main';
import { mainRoutes, HomePage } from './main';
import { authRoutes } from './auth';
import { authDemoRoutes } from './auth-demo';
import { dashboardRoutes,superadminroutes,clientroutes,karntekroutes, contractorRoutes } from './dashboard';
import { componentsRoutes } from './components';
 
export default function Router() {
  return useRoutes([
    {
      path: '/',
      element: (
        <MainLayout>
          <HomePage />
        </MainLayout>
      ),
    },
    // Auth routes
    ...authRoutes,
    // ...authDemoRoutes,

    // Dashboard routes
    ...dashboardRoutes,
    ...karntekroutes,
    ...contractorRoutes,
    ...superadminroutes,
    ...clientroutes,
    // Main routes
    ...mainRoutes,
    // Components routes
    ...componentsRoutes,
    // No match 404
    { path: '*', element: <Navigate to="/admin/login" replace /> },
  ]);
}
